import React from "react";
import { Link } from "react-router-dom";
import Logo from "../static/pol_log.png";
import "./FooterNew.css";

const serviceAreas = [
  "Edison", "Woodbridge", "Piscataway", "South Plainfield", 
  "Metuchen", "Highland Park", "New Brunswick", "East Brunswick",
  "North Brunswick", "Monroe", "Old Bridge", "Sayreville"
];

export default function FooterNew() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-container">
          {/* Brand Column */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src={Logo} alt="Polania Construction" />
            </Link>
            <p className="footer-tagline">
              Bringing Polish masonry excellence to Central New Jersey since 1985. 
              Four decades of craftsmanship you can trust.
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/PolaniaConstruction" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/polaniapolishmason?igsh=b21leGM3NDFyamxy" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h4 className="footer-heading">Quick Links</h4>
            <nav className="footer-nav">
              <Link to="/">Home</Link>
              <Link to="/services">Services</Link>
              <Link to="/portfolio">Portfolio</Link>
              <Link to="/about">About Us</Link>
              <Link to="/estimate">Get Estimate</Link>
            </nav>
          </div>

          {/* Services */}
          <div className="footer-column">
            <h4 className="footer-heading">Our Services</h4>
            <nav className="footer-nav">
              <Link to="/services">Brick Steps</Link>
              <Link to="/services">Paver Installation</Link>
              <Link to="/services">Concrete Work</Link>
              <Link to="/services">Retaining Walls</Link>
              <Link to="/services">Drainage Solutions</Link>
            </nav>
          </div>

          {/* Contact */}
          <div className="footer-column">
            <h4 className="footer-heading">Contact Us</h4>
            <div className="footer-contact">
              <a href="tel:7322050086" className="contact-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                (732) 205-0086
              </a>
              <a href="tel:7325258118" className="contact-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                (732) 525-8118
              </a>
              <a href="mailto:polaniaconstruction@gmail.com" className="contact-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                polaniaconstruction@gmail.com
              </a>
            </div>
          </div>
        </div>

        {/* Service Areas */}
        <div className="footer-areas">
          <h4 className="areas-heading">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
            Proudly Serving Central New Jersey
          </h4>
          <div className="areas-list">
            {serviceAreas.map((area, index) => (
              <span key={index} className="area-tag">{area}</span>
            ))}
            <span className="area-tag area-more">& Surrounding Areas</span>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-container footer-bottom-content">
          <p className="footer-legal">
            © {currentYear} Polania Construction. All Rights Reserved.
          </p>
          <p className="footer-license">
            NJ Home Improvement Contractor License #13VH12000800
          </p>
        </div>
      </div>
    </footer>
  );
}
